import { useParams } from "react-router-dom";
import { PATH_DASHBOARD } from "../routes/paths";

export const useAccountRelativeLink = () => {
    const { subId } = useParams()
    return PATH_DASHBOARD.sub.view(subId).root
}